export default __webpack_public_path__ + "static/media/dining.b461ad27.jpg";